<nav class="topbar" [class.nav-open]="navOpen">
  <!-- LEFT: Logo -->
  <a routerLink="/" class="logo">
    <img [src]="logoPath" alt="TutorOnTip Logo" />
  </a>

  <!-- CENTER: Nav Links -->
  <ul class="nav-links">

    <li class="dropdown-parent" (mouseenter)="showCourses=true" (mouseleave)="showCourses=false">
      <a class="dropdown-toggle-link" [class.active]="showCourses">
        All Courses <span class="arrow">▾</span>
      </a>

      <ul class="dropdown-menu-custom" *ngIf="showCourses">

        <li class="has-submenu" (mouseenter)="showStudents=true" (mouseleave)="showStudents=false">
          <span>Classes <span class="arrow">›</span></span>
          <ul class="submenu" *ngIf="showStudents">
            <li><a routerLink="/Class/Class1_5">Class 1-5</a></li>
            <li><a routerLink="/Class/Class6_8">Class 6-8</a></li>
            <li><a routerLink="/Class/Class9_10">Class 9-10</a></li>
            <li><a routerLink="/Class/Class11_12">Class 11-12</a></li>
          </ul>
        </li>

        <li class="has-submenu" (mouseenter)="showSubjects=true" (mouseleave)="showSubjects=false">
          <span>Subjects <span class="arrow">›</span></span>
          <ul class="submenu" *ngIf="showSubjects">
            <li><a routerLink="/subjects/maths">Maths</a></li>
            <li><a routerLink="/subjects/science">Science</a></li>
            <li><a routerLink="/subjects/english">English</a></li>
            <li><a routerLink="/subjects/history">History</a></li>
          </ul>
        </li>

        <li class="has-submenu" (mouseenter)="showLanguage=true" (mouseleave)="showLanguage=false">
          <span>Language <span class="arrow">›</span></span>
          <ul class="submenu" *ngIf="showLanguage">
            <li><a routerLink="/languages/marathi">Marathi</a></li>
            <li><a routerLink="/languages/hindi">Hindi</a></li>
            <li><a routerLink="/languages/sanskrit">Sanskrit</a></li>
            <li><a routerLink="/languages/german">German</a></li>
          </ul>
        </li>
      </ul>
    </li>

    <li><a routerLink="/teacher" routerLinkActive="active">Teacher</a></li>
    <li><a routerLink="/about"   routerLinkActive="active">About</a></li>
    <li><a routerLink="/contact" routerLinkActive="active">Contact Us</a></li>
  </ul>

  <!-- RIGHT: Theme Toggle + Auth -->
  <div class="right-actions">
    <div class="theme-toggle">
      <span>Light</span>
      <label class="switch">
        <input type="checkbox" [checked]="theme.isDark()" (change)="theme.toggle()" />
        <span class="slider"></span>
      </label>
      <span>Dark</span>
    </div>

    <a *ngIf="!(isLoggedIn$ | async)" [routerLink]="['/login']" class="btn-login">
      Login
    </a>

    <div *ngIf="isLoggedIn$ | async" class="profile-menu">
      <button class="profile-btn" (click)="toggleProfileMenu()" aria-label="Profile">
         👤
      </button>
      <div *ngIf="showProfileMenu" class="dropdown-menu">
        <div class="dropdown-role">
          {{ (user$ | async)?.role | titlecase }}
        </div>
        <hr>
        <a href="javascript:void(0)" class="dropdown-item" (click)="goToProfile()">
          My Profile
        </a>
        <!-- <a href="javascript:void(0)" class="dropdown-item" (click)="goToSettings()">
          Settings
        </a> -->
        <button (click)="logout()" class="dropdown-item logout-btn">
          Logout
        </button>
      </div>
    </div>

    <!-- Hamburger (mobile only) -->
    <button class="menu-toggle" (click)="toggleNav()" aria-label="Toggle navigation menu">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</nav>
